import {
  PrejudiceFormValeur,
  PrejudiceType,
} from '../../../types/prejudice.type';
import { prejudiceBaseDefaultValues } from '../defaultValues';

export const displayPartResponsabiliteField = (prejudiceType: PrejudiceType) =>
  Boolean(prejudiceType === 'PREJUDICE_IMPREPARATION_MEDICALE');

export const valeurDefaultValues = ({
  values,
  procedurePartResponsabilite,
  prejudiceType,
  multiplyPartResponsabilite,
}: {
  values?: Partial<PrejudiceFormValeur>;
  procedurePartResponsabilite: number;
  prejudiceType: PrejudiceType;
  multiplyPartResponsabilite: boolean;
}): PrejudiceFormValeur => ({
  ...prejudiceBaseDefaultValues({
    values,
  }),
  notes: values?.notes || '',
  argument: values?.argument || '',
  montant: values?.montant || 0,
  numerosPieces: values?.numerosPieces || {
    rows: [],
  },
  partResponsabilite:
    (!displayPartResponsabiliteField(prejudiceType)
      ? procedurePartResponsabilite
      : values?.partResponsabilite || values?.partResponsabilite === 0
      ? values?.partResponsabilite
      : procedurePartResponsabilite) * (multiplyPartResponsabilite ? 100 : 1),
});
